import { Coupon } from '../../models/subscription/types';

export const getUniqueCoupons = (coupons: Coupon[]) => {
  return [...new Map(coupons.map((item) => [item.code, item])).values()];
};
